// **********************************************************
// Product Variation
// **********************************************************

// Populate variation data on single product page
let voucherUnitPrice = null;

const populateVariation = (data) => {
  const root = document;
  const isVoucher = !!root.querySelector('[data-voucher-attribute]');
  const priceEle = root.querySelector('.product-module__price');

  if (priceEle) {
    priceEle.innerHTML = data.prices.current_price;
    priceEle.dataset.currentPrice = data.prices.current_price_data;
  }

  const addToCartLabel = document.querySelector('.product-module__add-to-cart .d-sm-none');
  if (addToCartLabel) {
    addToCartLabel.innerHTML = `(${data.prices.current_price})`;
  }

  const variationInput = root.querySelector('.variation-id') || document.querySelector('.variation-id');
  if (variationInput) {
    variationInput.value = data.variation_id;
  }

  const addToCartBtn =
    root.querySelector('.product-module__add-to-cart .btn, .product-popup__add-to-cart .btn') ||
    document.querySelector('.product-module__add-to-cart .btn');
  if (addToCartBtn) {
    addToCartBtn.disabled = !data.is_in_stock;
    addToCartBtn.classList.toggle('is-disabled', !data.is_in_stock);
    if (data.add_to_cart_btn_text && !isVoucher) {
      addToCartBtn.innerHTML = data.add_to_cart_btn_text;
    }
  }

  if (isVoucher) {
    const price = Number(data.prices.current_price_data);
    voucherUnitPrice = data.is_in_stock && data.variation_id > 0 && Number.isFinite(price) ? price : null;
    const wrapper = root.querySelector('.product-module__add-to-cart');
    if (wrapper && data.add_to_cart_btn_text) wrapper.dataset.voucherCartLabel = data.add_to_cart_btn_text;
    setVoucherPurchaseEnabled(data.is_in_stock && data.variation_id > 0);
    updateVoucherCartLabel();
  }

  updateFindStoreModal(data);
};

const setVoucherPurchaseEnabled = (enabled) => {
  const wrapper = document.querySelector('.product-module__add-to-cart');
  const button = wrapper?.querySelector('.btn');
  wrapper?.classList.toggle('is-disabled', !enabled);
  button?.classList.toggle('btn--disabled', !enabled);
  button?.setAttribute('aria-disabled', String(!enabled));
};

const clearVoucherVariation = () => {
  const input = document.querySelector('.variation-id');
  if (input) input.value = 0;
  voucherUnitPrice = null;
  setVoucherPurchaseEnabled(false);
  updateVoucherCartLabel();
};

const getVoucherQuantity = (root = document) => {
  const input = root.querySelector('#quantity-counter');
  const quantity = Math.max(1, parseInt(input?.value, 10) || 1);
  const max = parseInt(input?.getAttribute('max'), 10);
  return max > 0 ? Math.min(quantity, max) : quantity;
};

const updateVoucherCartLabel = () => {
  const wrapper = document.querySelector('.product-module__add-to-cart');
  const text = wrapper?.querySelector('.btn')?.querySelector('.btn__text');
  if (!text) return;
  const label = wrapper.dataset.voucherCartLabel || text.textContent;
  wrapper.dataset.voucherCartLabel = label;
  text.textContent = voucherUnitPrice === null ? label : `${label} (${euro.format(voucherUnitPrice * getVoucherQuantity())})`;
};

attachEvent('.product-module .quantity-counter__input', 'change', () => {
  if (document.querySelector('[data-voucher-attribute]')) updateVoucherCartLabel();
});

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const firstValue = (object, keys) => {
  for (const key of keys) {
    if (object && object[key] !== undefined && object[key] !== null && object[key] !== '') return object[key];
  }
  return '';
};

const getStoreCardMarkup = (store) => {
  const pim = store.pim || store.pim_store || store.store_identity || {};
  const display = store.display || store.store_data || store.store_display || store.store || store;
  const stockData = typeof store.stock === 'object' ? store.stock : {};
  const name =
    firstValue(display, ['name', 'title', 'store_name', 'branch_name']) ||
    firstValue(pim, ['name', 'title', 'store_name']) ||
    firstValue(store, ['name', 'title', 'store_name', 'branch_name']);
  const address = firstValue(display, ['address', 'store_address']) || firstValue(store, ['address']);
  const location = firstValue(display, ['location', 'text', 'branch_location']) || firstValue(store, ['location', 'branch_location']);
  const info = firstValue(display, ['info', 'open_text', 'opening_hours', 'openingHours', 'hours']) || firstValue(store, ['info', 'open_text', 'opening_hours', 'hours']);
  const sizes = firstValue(store, ['sizes', 'available_sizes']) || firstValue(stockData, ['sizes', 'available_sizes']) || [];
  const availableSizesText =
    firstValue(store, ['available_sizes_text', 'available_sizes_label', 'sizes_title']) ||
    firstValue(stockData, ['available_sizes_text', 'available_sizes_label', 'sizes_title']);
  const identity =
    firstValue(pim, ['store_id', 'id', 'pim_id']) ||
    firstValue(store, ['pim_store_id', 'store_id', 'id', 'pim_id']) ||
    firstValue(display, ['store_id', 'id']);
  const searchText = `${name} ${address} ${location}`.toLowerCase();
  const sortedSizes = Array.isArray(sizes)
    ? sizes
        .map((size, index) => ({
          size,
          index,
          numericLabel: Number.parseFloat(String(firstValue(size, ['label', 'text', 'size'])).replace(',', '.')),
        }))
        .sort((a, b) => {
          if (Number.isNaN(a.numericLabel) && Number.isNaN(b.numericLabel)) return a.index - b.index;
          if (Number.isNaN(a.numericLabel)) return 1;
          if (Number.isNaN(b.numericLabel)) return -1;
          return a.numericLabel - b.numericLabel || a.index - b.index;
        })
        .map(({ size }) => size)
    : [];
  const sizeMarkup = sortedSizes.length
    ? `<div class="store-card__sizes">
        ${availableSizesText ? `<div class="store-card__sizes-title text--10 text--gray-500 text--md"><p>${escapeHtml(availableSizesText)}</p></div>` : ''}
        <div class="store-card__sizes-list">${sortedSizes.map((size) => {
          const sizeStatus = String(firstValue(size, ['status', 'stock_status', 'availability']) || 'out-of-stock')
            .toLowerCase()
            .replace(/_/g, '-');
          const safeSizeStatus = sizeStatus === 'out-of-stock' || sizeStatus === '0' ? 'out-of-stock' : 'in-stock';
          const label = firstValue(size, ['label', 'text', 'size']);
          return `<div class="store-card__size text--10 text--sb d-flex-cc ${safeSizeStatus}"><span>${escapeHtml(label)}</span></div>`;
        }).join('')}</div>
      </div>`
    : '';

  return `<div class="store-card" data-store="${escapeHtml(identity)}" data-store-search="${escapeHtml(searchText)}">
    <div class="store-card__content">
      <div class="store-card__title text--14 text--sb text--gray-950">${escapeHtml(name)}</div>
      ${address && location ? `<div class="store-card__text text--12 text--md text--gray-500">${escapeHtml(location)}</div>` : ''}
      ${info ? `<div class="store-card__info text--gray-950 text--12 text--md"><span>${escapeHtml(info)}</span></div>` : ''}
      ${sizeMarkup}
    </div>
  </div>`;
};

const clearFindStoreCards = (modal) => {
  const list = modal?.querySelector('.modal__store-list-inner');
  if (list) list.replaceChildren();
  modal?.querySelector('[data-not-found]')?.classList.add('hide');
};

const setFindStoreLoading = (modal, isLoading) => {
  const results = modal?.querySelector('[data-inventory-results]');
  const loader = modal?.querySelector('[data-inventory-loader]');
  if (!results) return;

  results.classList.toggle('show-loader', isLoading);
  results.setAttribute('aria-busy', String(isLoading));
  loader?.setAttribute('aria-hidden', String(!isLoading));
};

const beginFindStoreInventoryRequest = (modal) => {
  if (!modal) return;

  modal.dataset.inventoryRequestId = String(Number(modal.dataset.inventoryRequestId || 0) + 1);
  clearFindStoreCards(modal);
  setFindStoreLoading(modal, true);
};

const isVariableProduct = () => {
  const flag = document.querySelector('[data-product-is-variable]');
  return !flag || flag.dataset.productIsVariable === '1';
};

const showFindStoreNoResults = (modal) => {
  clearFindStoreCards(modal);
  modal?.querySelector('[data-not-found]')?.classList.remove('hide');
  document.querySelector('.product-module__add-to-cart .btn')?.classList.remove('is-loading');
};

const syncFindStoreProductCard = () => {
  const modal = document.querySelector('.product-module .find-store-modal');
  const image = document.querySelector('.product-module .product-showcase img');
  const modalImage = modal?.querySelector('.product-card img');
  if (image && modalImage) {
    modalImage.src = image.dataset.src || image.currentSrc || image.src;
    modalImage.alt = image.alt;
  }
};

const syncFindStoreControls = () => {
  const modal = document.querySelector('.product-module .find-store-modal');
  if (!modal) return;

  const productInputs = Array.from(document.querySelectorAll('.product-module input[type="radio"]:checked, .product-module input[type="checkbox"]:checked')).filter(
    (input) => !input.closest('.find-store-modal'),
  );
  const selections = Array.from(productInputs).map((input) => [input.value, input.dataset.text]);
  modal.querySelectorAll('.dropdown').forEach((dropdown) => {
    dropdown.querySelectorAll('input').forEach((input) => {
      input.checked = selections.some(([value, text]) => value === input.value || text === input.dataset.text);
    });
    const checked = dropdown.querySelector('input:checked');
    const placeholder = dropdown.querySelector('.dropdown__placeholder-text');
    if (placeholder && checked) placeholder.textContent = checked.dataset.text || checked.value;
  });
};

const updateFindStoreModal = (data) => {
  const modal = document.querySelector('.product-module .find-store-modal');
  if (!modal) return;
  syncFindStoreControls();
  syncFindStoreProductCard();
  const stores = data?.stores || data?.store_inventory;
  if (!stores || typeof stores !== 'object') return;
  const inventory = Array.isArray(stores)
    ? stores
    : Object.entries(stores).map(([pimStoreId, store]) => ({ ...store, pim_store_id: pimStoreId }));

  const list = modal.querySelector('.modal__store-list-inner');
  if (!list) return;
  list.innerHTML = inventory.map(getStoreCardMarkup).join('');
  const notFound = modal.querySelector('[data-not-found]');
  if (notFound) notFound.classList.toggle('hide', inventory.length > 0);
  filterFindStoreCards(modal);
};

const filterFindStoreCards = (modal) => {
  const input = modal.querySelector('.modal__search-bar input:not([type="hidden"])');
  const query = input?.value.trim().toLowerCase() || '';
  const selectedSizes = Array.from(modal.querySelectorAll('.modal__filter .size-selector input:checked')).map(
    (size) => (size.dataset.text || size.value).trim().toLowerCase(),
  );
  let visible = 0;
  modal.querySelectorAll('.modal__store-list-inner .store-card').forEach((card) => {
    const searchMatches = !query || card.dataset.storeSearch.includes(query);
    const sizeMatches =
      !selectedSizes.length ||
      selectedSizes.some((selectedSize) =>
        Array.from(card.querySelectorAll('.store-card__size')).some(
          (badge) =>
            (badge.textContent || '').trim().toLowerCase() === selectedSize &&
            badge.classList.contains('in-stock'),
        ),
      );
    const matches = searchMatches && sizeMatches;
    card.hidden = !matches;
    if (matches) visible += 1;
  });
  modal.querySelector('[data-not-found]')?.classList.toggle('hide', visible > 0);
};

const clearFindStoreFilters = (modal) => {
  if (!modal) return;

  const searchInput = modal.querySelector('.modal__search-bar input:not([type="hidden"])');
  if (searchInput) searchInput.value = '';

  modal.querySelectorAll('.modal__filter input').forEach((input) => {
    input.checked = false;
  });
  modal.querySelectorAll('.modal__filter .dropdown').forEach((dropdown) => {
    dropdown.classList.remove('is-selected', 'is-open');
    const placeholder = dropdown.querySelector('.dropdown__placeholder-text');
    if (placeholder) {
      placeholder.textContent = placeholder.dataset.placeholder || '';
      placeholder.removeAttribute('data-ehrm');
    }
  });

  modal.querySelectorAll('.modal__store-list-inner .store-card').forEach((card) => {
    card.hidden = false;
  });
  modal.querySelector('[data-not-found]')?.classList.add('hide');
};

const requestStoreInventoryForCurrentSelection = () => {
  const selectorsData = { lang: typeof localData !== 'undefined' ? localData?.lang || '' : '' };
  document
    .querySelectorAll('.product-module__dropdown, .product-module .color-selector, .product-popup .color-selector')
    .forEach((section) => {
      const input = section.querySelector('input:checked');
      if (input) selectorsData[`attribute_${input.name.replace('popup-', '')}`] = input.value;
    });
  const sizeInput = document.querySelector('input[name^="product-config-select"][name$="-size"]:checked');
  if (sizeInput) {
    selectorsData.attribute_size = sizeInput.value;
    selectorsData.size_unit = sizeInput.dataset.sizeUnit;
  }
  axiosGetVariation(selectorsData);
};

attachEvent('.find-store-modal .modal__search-bar input:not([type="hidden"])', 'input', (ev) => {
  filterFindStoreCards(ev.target.closest('.find-store-modal'));
});

attachEvent('.find-store-modal .modal__search-bar form', 'submit', (ev) => {
  ev.preventDefault();
  filterFindStoreCards(ev.target.closest('.find-store-modal'));
});

attachEvent('.find-store-modal .modal__filter .size-selector input', 'change', (ev) => {
  filterFindStoreCards(ev.target.closest('.find-store-modal'));
});

attachEvent('.find-store-modal .modal__filter-clear', 'click', (ev) => {
  ev.preventDefault();
  clearFindStoreFilters(ev.target.closest('.find-store-modal'));
});

attachEvent('.find-store-modal .dropdown input', 'click', (ev) => {
  const modalInput = ev.target;
  const productInput = Array.from(document.querySelectorAll('.product-module input[type="radio"], .product-module input[type="checkbox"]'))
    .filter((input) => !input.closest('.find-store-modal'))
    .find((input) => input.value === modalInput.value || input.dataset.text === modalInput.dataset.text);
  if (productInput && !productInput.checked) productInput.click();
  if (productInput && typeof getVariation === 'function') getVariation();
  const placeholder = modalInput.closest('.dropdown')?.querySelector('.dropdown__placeholder-text');
  if (placeholder) placeholder.textContent = modalInput.dataset.text || modalInput.value;
});

document.addEventListener(
  'click',
  (ev) => {
    const trigger = ev.target.closest?.('[data-find-store-modal-trigger]');
    if (!trigger) return;

    const isLiveProduct = typeof localData !== 'undefined' && localData?.apiURL && document.querySelector('.product-id');
    if (!isLiveProduct) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    const parent = trigger.closest('[data-modal-parent]');
    const modalId = trigger.getAttribute('data-id') || 'find-store-modal';
    const modal = Array.from(parent?.querySelectorAll('[data-modal]') || []).find(
      (candidate) => candidate.getAttribute('data-id') === modalId,
    );

    if (modal) {
      modal.classList.add('is-open-modal');
      document.body.classList.add('modal-open');
      if (typeof toggleBodyScrollLock === 'function') toggleBodyScrollLock(true);
    }

    clearFindStoreCards(modal);
    syncFindStoreProductCard();
    if (!isVariableProduct()) {
      showFindStoreNoResults(modal);
      return;
    }
    window.setTimeout(requestStoreInventoryForCurrentSelection, 0);
  },
  true,
);

// Get variation data axios
const getVariationApiUrl = () => {
  const configuredUrl = new URL(localData.apiURL, window.location.href);
  return `${window.location.origin}${configuredUrl.pathname}${configuredUrl.search}`;
};

let latestVariationRequestId = 0;

const axiosGetVariation = async (formData) => {
  if (!isVariableProduct()) {
    showFindStoreNoResults(document.querySelector('.product-module .find-store-modal'));
    return;
  }

  const variationRequestId = ++latestVariationRequestId;
  const isVoucherRequest = !!document.querySelector('[data-voucher-attribute]');
  if (isVoucherRequest) clearVoucherVariation();
  const formDataInput = new FormData();
  formDataInput.append('action', 'getProductVariation');
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('id', document.querySelector('.product-id').value);
  const addToCartButton = document.querySelector('.product-module__add-to-cart .btn');
  const findStoreModal = document.querySelector('.product-module .find-store-modal');
  const isFindStoreRequest = findStoreModal?.classList.contains('is-open-modal');
  if (isFindStoreRequest) beginFindStoreInventoryRequest(findStoreModal);
  const requestId = findStoreModal?.dataset.inventoryRequestId;
  if (addToCartButton) {
    addToCartButton.classList.add('is-loading');
  }

  try {
    const response = await axios.post(getVariationApiUrl(), formDataInput);
    if (
      variationRequestId === latestVariationRequestId &&
      (!isFindStoreRequest || findStoreModal?.dataset.inventoryRequestId === requestId)
    ) {
      populateVariation(response.data.data || response.data);
    }
  } catch (err) {
    console.error(err);
    if (isVoucherRequest && variationRequestId === latestVariationRequestId) clearVoucherVariation();
    if (isFindStoreRequest && findStoreModal?.dataset.inventoryRequestId === requestId) {
      showFindStoreNoResults(findStoreModal);
    }
  } finally {
    if (addToCartButton && variationRequestId === latestVariationRequestId) {
      addToCartButton.classList.remove('is-loading');
    }
    if (isFindStoreRequest && findStoreModal?.dataset.inventoryRequestId === requestId) {
      setFindStoreLoading(findStoreModal, false);
    }
  }
};
// get variation selected attributes and call axiosGetVariation
const getVariation = () => {
  const root = document;
  const selectors = root.querySelectorAll(
    '.product-module__dropdown, .product-module .color-selector, .product-popup .color-selector, .product-module [data-voucher-attribute]',
  );
  const selectorsData = { lang: typeof localData !== 'undefined' ? localData?.lang || '' : '' };
  let isAnyInputNull = false;
  let isMissingNonSize = false;
  selectors.forEach((section) => {
    const inputField = section.querySelector('input:checked');
    if (inputField === null) {
      isAnyInputNull = true;
      isMissingNonSize = true;
      return;
    }
    selectorsData[`attribute_${inputField.name.replace('popup-', '')}`] = inputField.value;
    section.classList.remove('is-validation-failed');
  });

  const sizeInput = root.querySelector('input[name^="product-config-select"][name$="-size"]:checked');
  if (sizeInput) {
    selectorsData.attribute_size = sizeInput.value;
    selectorsData.size_unit = sizeInput.dataset.sizeUnit;
    sizeInput.closest('.size-selector')?.classList.remove('is-validation-failed');
  } else if (root.querySelector('input[name^="product-config-select"][name$="-size"]')) {
    isAnyInputNull = true;
  }

  if (isMissingNonSize) {
    if (root.querySelector('[data-voucher-attribute]')) {
      latestVariationRequestId += 1;
      clearVoucherVariation();
    }
    return;
  }

  const hasSelectedAttribute = Object.keys(selectorsData).some((key) => key.startsWith('attribute_'));
  if (!isAnyInputNull || hasSelectedAttribute) axiosGetVariation(selectorsData);
};

// Click on single product radio selector
const listenToVariationChange = () => {
  document
    .querySelectorAll('.product-module input[type="radio"], .product-popup input[type="radio"]')
    .forEach((item) => {
      item.addEventListener('click', (event) => {
        if (item.name === 'cross-sell-product') {
          if (event.target.value) {
            window.location.href = event.target.value;
          }
        } else {
          if (item.name !== 'value') {
            const group = item.closest('.radio-selector-group');
            if (group) {
              group.querySelector('.radio-selector-group__title-text').innerHTML = item.dataset.text;
            }
          }
          getVariation();
        }
      });
    });
};

listenToVariationChange();

if (document.querySelector('[data-voucher-attribute]')) {
  clearVoucherVariation();
  if (typeof localData !== 'undefined' && localData?.apiURL) getVariation();
}

// **********************************************************
// Add to cart
// **********************************************************

// Open Cart Popup on add to cart success
const openCartPopupOnAddSuccess = (popupContent) => {
  const cartPopup = document.querySelector('.cart-popup');
  if (cartPopup) {
    const cartPopupContent = cartPopup.querySelector('.cart-popup__content');
    const isOpen = cartPopup.classList.contains('is-cart-open');
    cartPopupContent.innerHTML = popupContent;
    cartPopup.classList.remove('cart-popup--empty');
    cartPopup.classList.toggle('is-cart-open', !isOpen);
    toggleBodyScrollLock(!isOpen);
  }
};

// Add to cart axios
const axiosAddToCart = async (formData, formAction) => {
  const formDataInput = new FormData();
  formDataInput.append('action', formAction);
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('nonce', 'nonce');
  formDataInput.append('token', 'token');
  try {
    const response = await axios.post(localData.apiURL, formDataInput);
    openCartPopupOnAddSuccess(response.data.data.cart_content_html);
    updateCartNumber(response.data.data.cart_contents_count);
    if (response.data.data.add_to_cart?.items?.length) {
      pushEcommerceEvent('add_to_cart', response.data.data.add_to_cart);
    }
  } catch (err) {
    console.error(err);
  }
};

// Click on add to cart button
const handleAddToCartClick = (button) => {
  const productModule = button.closest('.product-module') || document;
  const sizeInput = productModule.querySelector('input[name="product-config-select-size"]');
  if (sizeInput && !productModule.querySelector('input[name="product-config-select-size"]:checked')) {
    sizeInput.closest('.size-selector')?.classList.add('is-validation-failed');
    return;
  }

  const quantityCounterEle = productModule.querySelector('#quantity-counter');
  const variationId = productModule.querySelector('.variation-id')?.value || 0;
  if (
    productModule.querySelector('[data-voucher-attribute]') &&
    (Number(variationId) <= 0 || productModule.querySelector('.product-module__add-to-cart')?.classList.contains('is-disabled'))
  ) {
    return;
  }
  const prodId = productModule.querySelector('.product-id')?.value || 0;
  axiosAddToCart(
    {
      product_id: prodId,
      variation_id: variationId,
      quantity: productModule.querySelector('[data-voucher-attribute]') ? getVoucherQuantity(productModule) : quantityCounterEle?.value || 1,
      voucher_recipient_name: '',
      voucher_your_name: '',
    },
    'addToCart',
  );
};
attachEvent('.product-module__add-to-cart:not(.is-disabled) a:not(.is-loading)', 'click', (ev) => {
  ev.preventDefault();
  handleAddToCartClick(ev.target);
});

const productModuleAnalytics = document.querySelector('.sc-product-module[data-analytics-item]');
if (productModuleAnalytics) {
  try {
    const analyticsItem = JSON.parse(productModuleAnalytics.dataset.analyticsItem);
    pushEcommerceEvent('view_item', { value: analyticsItem.price, items: [analyticsItem] });
  } catch (err) {
    console.error(err);
  }
}

// **********************************************************
// Wishlist toggle on single product
// **********************************************************

attachEvent('.product-module__wishlist', 'click', async (ev) => {
  ev.preventDefault();
  ev.stopPropagation();

  const btn = ev.target.closest('.product-module__wishlist');
  if (!btn) return;

  const { productId } = btn.dataset;
  if (!productId) return;

  btn.classList.toggle('is-active');

  if (typeof localData === 'undefined' || !localData?.apiURL) {
    return;
  }

  try {
    const nonce = await getNonceForAction('toggleItemOnLikedList');
    const formData = new FormData();
    formData.append('action', 'toggleItemOnLikedList');
    formData.append('productid', productId);
    formData.append('nonce', nonce);
    formData.append('lang', localData.lang);

    const { data } = await axios.post(localData.apiURL, formData);

    if (data.success) {
      const { count, active } = data.data;
      btn.classList.toggle('is-active', active);
      if (active && data.data.add_to_wishlist) {
        pushEcommerceEvent('add_to_wishlist', data.data.add_to_wishlist);
      }

      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    } else {
      btn.classList.toggle('is-active');
    }
  } catch (error) {
    btn.classList.toggle('is-active');
    console.error('Wishlist toggle error:', error);
  }
});
